module.exports = __webpack_public_path__ + "img/asthma.14c69d9c.png";